import React from 'react'
import { NavLink } from 'react-router-dom'
import { Box } from '@mui/material'

import { menu } from 'apps/common/utils'

export const Menu = ( { isLeftSide } ) => {

	return (
		<Box
			marginLeft='0'
			height={ isLeftSide ? 'auto' : '100%' }
			width='100%'
			position={ isLeftSide ? 'relative' : 'fixed' }
			top={ isLeftSide ? '0' : '54px' }
		>
			<Box
				alignItems='stretch'
				boxShadow={ isLeftSide ? 'none' : '0 3px 28px 0.5px #cdcdcd' }
				left={ isLeftSide ? '0' : '-16px' }
				position='relative'
				backgroundColor='bg.white'
				zIndex='9'
				width='100%'
				height='auto'
				display='flex'
				sx={{
					writingMode: isLeftSide ? 'tb' : 'horizontal-tb',
					transform: isLeftSide ? 'scale(-1)' : 'scale(1)',
					flexDirection: isLeftSide ? 'row-reverse' : 'column'
				}}
			>
				{ menu.map( ( { id, text, to } ) =>
					<NavLink
						to={ to }
						key={ id }
						cursor='var(--cursor-pointer)'
						activeClassName='selected'
						className='menu-btn'
					>
						{ text }
					</NavLink>
				)}
			</Box>
		</Box>
	)
}
